export default "__VITE_ASSET__BZVPF$RI__"